import React, { useEffect, useState, useContext } from 'react'
import label from '../../../../../../../../assets/i18n/en.json'
import ProviderServicesService from '../../../../../../../services/api/provider-services.service';
import APIResponse from '../../../../../../templates/components/APIResponse';
import MessageSetting from '../../../../../../../common/constants/message-setting.constant';
import DimLoader from '../../../../../../templates/components/DimLoader';
import { store } from '../../../../../../../context/StateProvider';
import { useGetAllPracticeServiceTypes } from '../../../../../../../services/cache/CacheService';
import ModalBox from '../../../../../../templates/components/ModalBox';
const ProviderServicesTable = (props) => {
    const globalStateAndDispatch = useContext(store)
    const dispatch = globalStateAndDispatch.dispatch
    const [services, setServices] = useState()
    const [isLoader, setIsLoader] = useState(false)
    const [isLookupLoader, setIsLookupLoader] = useState(false)
    const [serviceList, setServiceList] = useState()
    const [apiResponse, setApiResponse] = useState()
    const [successMessage, setSuccessMessage] = useState()
    const [addAll, setAddAll] = useState(false)
    const [deleteAll, setDeleteAll] = useState(false)
    const stateAllPracticeServiceTypeList = useGetAllPracticeServiceTypes()
    const [allServiceTypeList, setAllServiceTypeList] = useState()
    const onSuccess = (message) => {
        pullServices()
        dispatch({
            type: "setLocationProviderServices",
            payload: null
        });
    }

    useEffect(() => {
        //console.log("stateAllPracticeServiceTypeList ::"+ JSON.stringify(stateAllPracticeServiceTypeList))
        if (stateAllPracticeServiceTypeList) {
            setAllServiceTypeList(stateAllPracticeServiceTypeList)
        }
    }, [stateAllPracticeServiceTypeList])

    useEffect(() => {
        //console.log("allServiceTypeList ::"+ JSON.stringify(allServiceTypeList))
        if (allServiceTypeList) {
            pullServices()
        }
    }, [allServiceTypeList])

    const pullServices = () => {
        setServiceList()
        setServices()
        setIsLookupLoader(true)
        ProviderServicesService.findServicesByProvider(props.id)
            .then(res => {
                let selectedServices = res.data
                setServices(selectedServices)
                let allServiceTypes = allServiceTypeList.map(service => ({...service, providerHas: 0}))
                selectedServices.forEach(selectedService => {
                    const matchingService = allServiceTypes.find(obj => 
                        obj.practiceServiceTypeId === selectedService.practiceServiceTypeTypeDetails.practiceServiceTypeId
                    )
                    if (matchingService) {
                        matchingService.providerHas = 1
                    }
                })
                return setServiceList(allServiceTypes.filter(obj => !obj.providerHas))
            })
            .finally(() => {
                setIsLookupLoader(false)
            });
    }

    const addAllServices = (serviceList) => {
        setIsLoader(true)
        let practiceServiceTypeIds = serviceList.map(item => item.practiceServiceTypeId);
        let reqObj = { practiceServiceTypeIds: practiceServiceTypeIds.join(','), doctorId: props.id }
        ProviderServicesService.addAllProviderServices(reqObj)
            .then(res => {
                setSuccessMessage(MessageSetting.ProviderService.add)
                setApiResponse(res)
            })
            .catch(err => {
                setApiResponse(err)
            })
            .finally(() => {
                setIsLoader(false)
            });
    }

    const deleteAllServices = (services) => {
        setIsLoader(true)
        let reqObj = {
            practitionerServiceTypeIds: services.map(service => service.practitionerServiceTypeId).join(','),
            doctorId: props.id
        }
        ProviderServicesService.deleteAllProviderServices(reqObj)
            .then(res => {
                setSuccessMessage(MessageSetting.ProviderService.delete)
                setApiResponse(res)
            })
            .catch(err => {
                setApiResponse(err)
            })
            .finally(() => {
                setIsLoader(false)
            });
    }
    return (
        <>
            {isLoader || isLookupLoader ? <DimLoader loadMessage={isLookupLoader ? "Loading..." : label.common.processing} /> : null}
            <div className='d-flex row'>
                <div className='col-md-8 col-12'>
                    <div className='card'>
                        <div className='card-header'>
                            <div className="row d-flex align-items-center justify-content-between">
                                <span className='col-md-auto col-12'>Active Services</span>
                                <div className='col-md-auto col-12'>
                                    <button className="btn btn-primary" onClick={e => { e.preventDefault(); setDeleteAll(true) }}>Delete All</button>
                                </div>
                            </div>
                        </div>
                        <div className='card-body row d-flex'>
                            {services && services.map((service, i) => {
                                return (
                                    <div className='col-md-3 col-12' key={i}>
                                        <span title="Remove Service" className='text-start point' onClick={e => { e.preventDefault(); deleteAllServices([service]) }}><i className='icon minus small position-relative' /> {service?.practiceServiceTypeTypeDetails?.practiceServiceType} </span>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
                <div className='col-md-4 col-12'>
                    <div className='card'>
                        <div className='card-header'>
                            <div className="row d-flex align-items-center justify-content-between">
                                <span className='col-md-auto col-12'>Inactive Services</span>
                                <div className='col-md-auto col-12'>
                                    <button className="btn btn-primary" onClick={e => { e.preventDefault(); setAddAll(true) }}>Add All</button>
                                </div>
                            </div>
                        </div>
                        <div className='card-body row d-flex'>
                            {serviceList && serviceList.map((service, i) => {
                                return (
                                    <div className='col-md-6 col-12' key={i}>
                                        <span title="Add Service" className='text-start point' onClick={e => { e.preventDefault(); addAllServices([service]) }}><i className='icon plus small position-relative' /> {service?.practiceServiceType}</span>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
            <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true} successMessage={successMessage} />
            
            <ModalBox open={addAll} onClose={() => { setAddAll(false) }} title="Confirm">
                <div className="d-flex row justify-content-between">
                    <div className="col-12 mb-3">
                        Are you sure you want to add all services to this provider?
                    </div>
                    <div className="col-auto">
                        <button className="btn btn-primary" onClick={e => { e.preventDefault(); setAddAll(false); addAllServices(serviceList) }}>
                            Confirm
                        </button>
                    </div>
                    <div className="col-auto">
                        <button className="btn btn-secondary" onClick={e => { e.preventDefault(); setAddAll(false) }}>
                            Cancel
                        </button>
                    </div>
                </div>
            </ModalBox>

            <ModalBox open={deleteAll} onClose={() => { setDeleteAll(false) }} title="Confirm">
                <div className="d-flex row justify-content-between">
                    <div className="col-12 mb-3">
                        Are you sure you want to delete all services from this provider?
                    </div>
                    <div className="col-auto">
                        <button className="btn btn-primary" onClick={e => { e.preventDefault(); setDeleteAll(false); deleteAllServices(services) }}>
                            Confirm
                        </button>
                    </div>
                    <div className="col-auto">
                        <button className="btn btn-secondary" onClick={e => { e.preventDefault(); setDeleteAll(false) }}>
                            Cancel
                        </button>
                    </div>
                </div>
            </ModalBox>
        </>
    )
}

export default ProviderServicesTable